import auth from '../../../config/app-specific-config/auth';
import * as types from './users-profile-actions-types';
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig';
import { displayModeCheck } from '../../global/helpers/global-helpers';
import { setIsMobileView } from '../../global/actions/global-actions';
import { getUserExternalIntegrations } from './users-external-integration-actions';
import { getTimestampForFileName } from '../../global/helpers/time-format-helpers';
import { setUserPrivileges } from '../../auth/actions/auth-actions';


// Setting User Information
export const setThisUserAccountProfile = (p) => {
	return {
		type: types.SET_USER_ACCOUNT_PROFILE,
		payload: p
	};
};

export const setUserProfilePicture = (p) => {
	return {
		type: types.SET_USER_PROFILE_PICTURE,
		payload: p
	};
};

export const setUserIsOrgAdmin = (isOrgAdmin) => {
	return {
		type: types.SET_USER_IS_ORG_ADMIN,
		payload: isOrgAdmin
	};
};


export const setUserSettings = (p) => {
	return {
		type: types.SET_USER_SETTINGS,
		payload: p
	};
};


export const getUserProfileSuccess = (response) => {
	return {
		type: types.GET_USER_PROFILE_SUCCESS,
		payload: response.data
	};
};

export const getUserProfileFailure = (error) => {
	return {
		type: types.GET_USER_PROFILE_FAILURE,
		error
	};
};

export const getUserProfileRequest = () => {
	
	return {
		type: types.GET_USER_PROFILE_REQUEST
	};
};

export const getUserProfile = ({
	getContactDetails, 
	getUserInfo, 
	getUserOrgInfo, 
	getUserMetaData,
	getIntegrationStatuses
}) => {
	return async (dispatch) => {

		dispatch(getUserProfileRequest());
	
		try {
			const url = `/me/info`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(
				url,
				{
					getContactDetails,
					getUserInfo,
					getUserOrgInfo,
					getUserMetaData
				},
				{ headers }
			);
			
			if (!!response.data.data.logUserOut) {
				// Log out inactive users
				dispatch(setThisUserAccountProfile({logUserOut: true}));

			} else {
				const {userPrivileges, userMetaData, userOrgProfile , userPersonalProfile = {}, userType} = response.data.data || {}
				userPrivileges && dispatch(setUserPrivileges(userPrivileges))
	
				const {isAdministrator, ...deconUserOrgProfile} = userOrgProfile || {}

				if (userType) {
					localStorage.setItem('USER_CATG', userType); 
				}

				dispatch(setUserIsOrgAdmin(isAdministrator || false));
				dispatch(setThisUserAccountProfile({
					...userPersonalProfile,
					...deconUserOrgProfile,
					...(userMetaData && {userMetaData})
				}));

				if (userPersonalProfile.profilePicture) {
					dispatch(setUserProfilePicture(userPersonalProfile.profilePicture + `?t=${getTimestampForFileName()}`))
				}

				if (getIntegrationStatuses === true) {
					dispatch(getUserExternalIntegrations())
				}


				// Mobile View setting
				const isMobileView = displayModeCheck();
				dispatch(setIsMobileView(isMobileView))

				dispatch(getUserProfileSuccess(response));
			}

		
		
		} catch (error) {
			dispatch(getUserProfileFailure(error));
		}
	};
}


// Upload Profile Picture

export const uploadProfilePictureSuccess = (response) => {
	return {
		type: types.UPLOAD_PROFILE_PICTURE_SUCCESS,
		payload: response.data
	};
};

export const uploadProfilePictureFailure = (error) => {
	return {
		type: types.UPLOAD_PROFILE_PICTURE_FAILURE,
		error
	};
};

export const uploadProfilePictureRequest = () => {
	return {
		type: types.UPLOAD_PROFILE_PICTURE_REQUEST
	};
};

export function uploadProfilePicture(values) {
	return async (dispatch) => {
		dispatch(uploadProfilePictureRequest());
		try {
			const profilePicture = new FormData(); 
			profilePicture.append('imageType', "user-profile-pic")  
			profilePicture.append('profilePicture', values)  
	

			const url = '/me/upload-profile-image';
			const headers = await auth.getAccessToken();
		
			const response = await axiosInstance.put(url, profilePicture, {headers});

			if (response.data.data.newProfilePicUrl) {
				dispatch(setUserProfilePicture(response.data.data.newProfilePicUrl + `?t=${getTimestampForFileName()}`))
			}

			dispatch(uploadProfilePictureSuccess(response));
		} catch (error) {
			dispatch(uploadProfilePictureFailure(error));
		}

	};
}


/////Edit User profile
export const editUserProfileSuccess = (response) => {
	return {
		type: types.EDIT_USER_PROFILE_SUCCESS,
		payload: response.data
	};
};

export const editUserProfileFailure = (error) => {
	return {
		type: types.EDIT_USER_PROFILE_FAILURE,
		error
	};
};

export const editUserProfileRequest = () => {
	return {
		type: types.EDIT_USER_PROFILE_REQUEST
	};
};

export const editUserProfile = (updatedUserParams) => {
	return async (dispatch) => {
		dispatch(editUserProfileRequest());
		try {
			const url = '/me';
			const headers = await auth.getAccessToken();
		
			const response = await axiosInstance.put(
				url,
				updatedUserParams,
				{ headers }
			);
			
			dispatch(setThisUserAccountProfile(response.data.data.updatedUser));
			dispatch(editUserProfileSuccess(response));
	
		} catch (error) {
			dispatch(editUserProfileFailure(error));
		}
	};
};


/////Update User Action Event

export const editUserActionEventSuccess = (response) => {
	return {
		type: types.UPDATE_USER_ACTION_EVENT_SUCCESS,
		payload: response.data
	};
};

export const editUserActionEventFailure = (error) => {
	return {
		type: types.UPDATE_USER_ACTION_EVENT_FAILURE,
		error
	};
};

export const editUserActionEventRequest = () => {
	return {
		type: types.UPDATE_USER_ACTION_EVENT_REQUEST
	};
};

export const updateUserActionEvent = (newActionEvent) => {
	return async (dispatch) => {
		dispatch(editUserActionEventRequest());
		try {
			const url = '/me/user-action-event';
			const headers = await auth.getAccessToken();

			const response = await axiosInstance.put(
				url,
				{
					newActionEvent
				},
				{ headers }
			);
			dispatch(editUserActionEventSuccess(response));
			
		} catch (error) {
			dispatch(editUserActionEventFailure(error));
		}
	};
};

/////

export const resendEmailVerificationSuccess = (response) => {
	return {
		type: types.RESEND_EMAIL_VERIFICATION_SUCCESS,
		payload: response.data
	};
};

export const resendEmailVerificationFailure = (error) => {
	return {
		type: types.RESEND_EMAIL_VERIFICATION_FAILURE,
		error
	};
};

export const resendEmailVerificationRequest = () => {
	return {
		type: types.RESEND_EMAIL_VERIFICATION_REQUEST
	};
};

export const resendEmailVerification = () => {
	return async (dispatch) => {
		dispatch(resendEmailVerificationRequest());
		try {
			const url = '/emailer/resend-verify-email';
			const headers = await auth.getAccessToken();

			const response = await axiosInstance.post(
				url,
				{},
				{ headers }
			);
			dispatch(resendEmailVerificationSuccess(response));
		} catch (error) {
			dispatch(resendEmailVerificationFailure(error));
		}
	};
};


/////Update User Email Settings
export const updateUserSettingsSuccess = (response) => {
	return {
		type: types.UPDATE_USER_SETTINGS_SUCCESS,
		payload: response.data
	};
};

export const updateUserSettingsFailure = (error) => {
	return {
		type: types.UPDATE_USER_SETTINGS_FAILURE,
		error
	};
};

export const updateUserSettingsRequest = () => {
	return {
		type: types.UPDATE_USER_SETTINGS_REQUEST
	};
};


export const updateUserSettings = (settingsPayload) => {
	return async (dispatch) => {
		dispatch(updateUserSettingsRequest());
		try {
			const url = '/me/user-settings';
			const headers = await auth.getAccessToken();
		
			const response = await axiosInstance.put(
				url,
				settingsPayload,
				{ headers }
			);

			if (response.data.data) {
				dispatch(getUserSettings({ 
					emailSettingsRequest: true, 
					bannerSettingsRequest: true, 
					checkDemoSignupUserRequest: false 
				}))
			}
		

			dispatch(updateUserSettingsSuccess(response));
	
		} catch (error) {
			dispatch(updateUserSettingsFailure(error));
		}
	};
};

/////Get User Email Settings
export const getUserSettingsSuccess = (response) => {
	return {
		type: types.GET_USER_SETTINGS_SUCCESS,
		payload: response.data
	};
};

export const getUserSettingsFailure = (error) => {
	return {
		type: types.GET_USER_SETTINGS_FAILURE,
		error
	};
};

export const getUserSettingsRequest = () => {
	return {
		type: types.GET_USER_SETTINGS_REQUEST
	};
};

export const getUserSettings = (requestPayload) => {
	return async (dispatch) => {
		dispatch(getUserSettingsRequest());
		try {
			const {emailSettingsRequest, bannerSettingsRequest, checkDemoSignupUserRequest} = requestPayload || {};

			const url = `/me/get-user-settings?email=${emailSettingsRequest}&banner=${bannerSettingsRequest}&checkDemoSignupUser=${checkDemoSignupUserRequest}`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.get(url, {headers});

			dispatch(setUserSettings(response.data))

			dispatch(getUserSettingsSuccess(response));
	
		} catch (error) {
			dispatch(getUserSettingsFailure(error));
		}
	};
};

/////Update User Password
export const updateUserPasswordSuccess = (response) => {
	return {
		type: types.UPDATE_USER_PASSWORD_SUCCESS,
		payload: response.data
	};
};

export const updateUserPasswordFailure = (error) => {
	return {
		type: types.UPDATE_USER_PASSWORD_FAILURE,
		error
	};
};

export const updateUserPasswordRequest = () => {
	return {
		type: types.UPDATE_USER_PASSWORD_REQUEST
	};
};

export const updateUserPassword = (currentPasswordInput, newPassword) => {
	return async (dispatch) => {
		dispatch(updateUserPasswordRequest());
		try {
			const url = '/me/user-new-pw';
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.put(
				url,
				{
					currentPasswordInput,
					newPassword
				},
				{ headers }
			);

			dispatch(updateUserPasswordSuccess(response));
	
		} catch (error) {
			dispatch(updateUserPasswordFailure(error));
		}
	};
};